import React, { useMemo } from 'react'
import SlideOverHelpPanel, { HelpFooterNote } from '../../pages/compliance-safe/components/SlideOverHelpPanel'
import { useScreenHelp } from '../../hooks/useScreenHelp'

export default function ScreenHelpPanel({
  screenKey,
  open,
  onClose,
  focusSectionId = 'overview',
  sectionIdPrefix = 'screen-help',
}) {
  const { data, loading } = useScreenHelp(screenKey)

  const sections = useMemo(() => {
    if (!data?.sections) return []
    return data.sections.map((s) => ({
      id: s.section_key,
      title: s.title,
      blocks: s.blocks,
    }))
  }, [data])

  const footer = data?.legal_footer?.text ? (
    <HelpFooterNote>
      <span className="text-slate-700">{data.legal_footer.text}</span>
    </HelpFooterNote>
  ) : null

  if (!open || loading || !data) return null

  return (
    <SlideOverHelpPanel
      open={open}
      onClose={onClose}
      title={data.title || 'Help'}
      subtitle={data.subtitle || ''}
      sections={sections}
      focusSectionId={focusSectionId}
      sectionIdPrefix={sectionIdPrefix}
      footer={footer}
    />
  )
}
